import { Teilimpfungsart } from '@/types/Teilimpfungsart';

export default class Planimpfung {
    /** PK: PatPlaeneImpfstoff | erforderlich */
    public patplanimpfstoff_id: number | null = null;
    /** FK: Plan | erforderlich */
    public patplan_id: number | null = null;
    /** FK: Impfstoff | erforderlich */
    public impfstoff_id: number | null = null;
    /** Verweis auf Tab. eImpf_Impfschema_VS | max. 10 Zeichen */
    public impfschema_code: string | null = null;
    /** Nummer der Teilimpfung */
    public teilimpfungsnr: number | null = null;
    /** Code der Impfung aus Altsystem | max. 8 Zeichen */
    public impfung_code: string | null = null;
    /** Bezeichnung der Impfung aus Altsystem | max. 50 Zeichen */
    public impfung: string | null = null;
    /** Geplantes Impfdatum  */
    public impfdatum_geplant: string | null = null;
    /** Geimpft Status | max. 1 Zeichen */
    public geimpft: string | null = 'n';
    /** Impfdatum  */
    public impfdatum: string | null = null;
    /**  */
    public zeitstempel: string | null = null;
    /** Patient hat Impfung abgelehnt j/n | max. 1 Zeichen */
    public abgelehnt: string | null = null;
    /** MUW | Kassa hat Impfung genehmigt j/n | max. 1 Zeichen */
    public genehmigt: string | null = null;
    public isDirty: boolean| null = null;

    public patuntersuchung_id: number | null = null;

    public impfstoff_impfstoff: string | null = null;
    public impfstoff_impfung: string | null = null;
    public impfstoff_verkaufspreis: number | null = null;
    public impfstoff_bezeichnung: string | null = null;
    public plan_datum: string | null = null;
    public plan_patnr: number | null = null;

    public get impfungsText(): string {
        if (this.impfstoff_id) {
            return `${this.impfstoff_impfung} (${this.impfstoff_bezeichnung})`;
        }

        if (this.impfung) {
            return this.impfung;
        }

        return '';
    }

    public get teilimpfungsKuerzel(): string {
        if (this.teilimpfungsnr !== null) {
            if (this.isAuffrischung) {
                return 'A. ';
            }

            if (this.isTeilimpfung) {
                return this.teilimpfungsnr + '. ';
            }
        }

        return '';
    }

    public get teilimpfungsText(): string {
        if (this.teilimpfungsnr !== null) {
            if (this.isAuffrischung) {
                return 'Auffrischung';
            }

            if (this.isTeilimpfung) {
                return this.teilimpfungsnr + '. Teilimpfung';
            }
        }

        return '';
    }

    public get isEinfachimpfung(): boolean {
        return this.teilimpfungsnr === Teilimpfungsart.Einfachimpfung;
    }

    public get isTeilimpfung(): boolean {
        return this.teilimpfungsnr === Teilimpfungsart.Teilimpfung1 ||
            this.teilimpfungsnr === Teilimpfungsart.Teilimpfung2 ||
            this.teilimpfungsnr === Teilimpfungsart.Teilimpfung3 ||
            this.teilimpfungsnr === Teilimpfungsart.Teilimpfung4;
    }

    public get isAuffrischung(): boolean {
        return this.teilimpfungsnr === Teilimpfungsart.Auffrischung;
    }

    constructor(data?: Partial<Planimpfung>) {
        Object.assign(this, data);
    }
}
